import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ShortenedSubmissionForm from './ShortenedSubmissionForm';
import Modal from '../common/Modal/Modal';
import utils from '../../lib/utils';
import linkUtils from '../../lib/linkUtils';
import {trackPageView} from '@forwardfinancing/analytics-frontend-library';

class ShortenedNewSubmissionPage extends React.Component {
  constructor() {
    super();
    this.state = {
      disabled: window.disableSubmissions || false
    };
  }

  componentDidMount() {
    trackPageView(linkUtils.getLocationName(this.props));
    this.checkIfAdmin();
  }

  componentDidUpdate(prevProps) {
    if (this.hasChanged(prevProps, 'isAdmin')) {
      this.checkIfAdmin();
    } else if (this.hasChanged(prevProps, 'dualFormAllowed')) {
      this.checkIfDualFormAllowed();
    }
  }

  hasChanged(prevProps, key) {
    return prevProps[key] !== this.props[key];
  }

  checkIfAdmin(){
    if (this.props.isAdmin){
      this.handleDismissOfCompleteMessage();
    }
  }

  checkIfDualFormAllowed() {
    // if partner access by url and is not allowed to use the shortened form
    // redirect to standard form
    if (!this.props.dualFormAllowed) {
      this.props.history.replace("/portal/new_submission");
    }
  }

  handleDismissOfCompleteMessage() {
    this.props.history.push("/portal");
  }

  render() {
    return (
      <div className="shortened-submission-page column page">
        <Modal
          isActive={this.state.disabled}
          error
          desiredClassName="form-completed-message"
          simpleMessageList={[`Sorry for the inconvenience,
            the submission page is temporarily unavailable.`,
            "Please try again later or contact your Account Manager."]}
          onClose={this.handleDismissOfCompleteMessage.bind(this)}
          withIndicator
        />
        {
          !this.state.disabled &&
          <ShortenedSubmissionForm />
        }
      </div>
    );
  }
}

ShortenedNewSubmissionPage.propTypes = {
  history: PropTypes.object.isRequired,
  location: PropTypes.object,
  dualFormAllowed: PropTypes.bool,
  isAdmin: PropTypes.bool
};

ShortenedNewSubmissionPage.defaultProps = {
  location: {}
};

export default withRouter(connect((state) => {
    return {
      isAdmin: state.user && utils.isAdmin(state.user.role),
      dualFormAllowed: state.partner && state.partner.fundingPartnerData.dual_form_view
    };
  }, {})(ShortenedNewSubmissionPage)
);
